// src/pages/warehouses/WarehousesPage.js

import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import WarehouseForm from './WarehouseForm';

const warehouseColumns = [
  { header: 'ID', key: '_id', render: (warehouse) => warehouse._id.substring(0, 8) + '...' },
  { header: 'Warehouse Name', key: 'name' },
  { header: 'Location', key: 'location', render: (warehouse) => warehouse.location || 'N/A' },
  { header: 'Contact Person', key: 'contactPerson', render: (warehouse) => warehouse.contactPerson || 'N/A' },
  { header: 'Contact Phone', key: 'contactPhone', render: (warehouse) => warehouse.contactPhone || 'N/A' },
  {
    header: 'Default',
    key: 'isDefault',
    render: (warehouse) => (
      <span className={warehouse.isDefault ? 'bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-semibold' : 'text-gray-500'}>
        {warehouse.isDefault ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    header: 'Status',
    key: 'isActive',
    render: (warehouse) => (
      <span className={warehouse.isActive ? 'bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-semibold' : 'bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-semibold'}>
        {warehouse.isActive ? 'Active' : 'Inactive'}
      </span>
    ),
  },
];

const WarehousesPage = () => {
  const warehouseFilterConfig = useMemo(() => [
    {
      name: 'name',
      type: 'text',
      label: 'Warehouse Name',
    },
    {
      name: 'location',
      type: 'text',
      label: 'Location',
    },
    {
      name: 'isActive',
      type: 'select',
      label: 'Status',
      options: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' },
      ],
    },
  ], []);

  return (
    <GenericListPage
      title="Warehouses"
      permission="manage_warehouses"
      entityEndpoint="warehouses"
      columns={warehouseColumns}
      FormComponent={WarehouseForm}
      filterConfig={warehouseFilterConfig}
    />
  );
};

export default WarehousesPage;
